<template>
  <v-container v-if="cliente">
    <Navbar
      :hasBackButton="true"
      :hasTabs="true"
      :tabsHeader="['Dados', 'Contato', 'Info']"
      :paddingTabs="false"
      @backButtonClicked="cancel"
      @tabChanged="currentTab = $event"
      :title="`Cliente #${id}`"
    >
      <template slot="actions">
        <v-btn text @click="save">
          Salvar
        </v-btn>
        <Menu
          :disabled="permiteAlterar(cliente)"
          :items="menuItems"
          @excluir="removeCliente"
        />
      </template>
      <!-- Tabs -->
      <v-row column slot="Dados" class="grey lighten-3">
        <v-col cols="12" class="pt-0">
          <v-card class="mb-3" :disabled="!!cliente.id_cliente">
            <v-card-text>
              <v-form ref="formCliente" v-model="valid" lazy-validation>
                <v-row wrap>
                  <v-col cols="12" md="8" class="pt-0">
                    <v-radio-group label="Tipo" v-model="computedTipoPessoa" row hide-details class="ma-0">
                      <v-radio label="Física" value="F" color="primary"></v-radio>
                      <v-radio label="Jurídica" value="J" color="primary"></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="12" md="8" class="py-0">
                    <v-text-field
                      v-model="cliente.razao_social"
                      label="Nome/Razão Social"
                      :rules="[rules.required]"
                      @change="changeNomeRazaoSocial"
                    ></v-text-field>
                    <v-text-field
                      v-model="cliente.nome_fantasia"
                      label="Apelido/Nome Fantasia"
                      :rules="[rules.required]"
                    ></v-text-field>
                    <v-text-field
                      v-model="cliente.contato"
                      label="Contato"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" class="py-0">
                    <v-text-field
                      v-model="cliente.cpf_cnpj"
                      label="CPF/CNPJ"
                      :rules="ruleCpfCnpj"
                    ></v-text-field>
                    <v-text-field
                      v-model="cliente.rg_ie"
                      label="RG/IE"
                    ></v-text-field>
                    <v-text-field v-model="cliente.inscricao_municipal" label="Inscrição Municipal"></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>

          <!-- Endereço -->
          <ModalClienteEndereco
            :modal="modalClienteEndereco"
            :editClienteEndereco="editClienteEndereco"
            @close="closeModalClienteEndereco"
            @save="addClienteEndereco"
            @update="updateClienteEndereco"
          />

          <!-- Button Modal Endereço -->
          <v-fab-transition>
            <v-btn
              v-if="currentTab === 'tab-Dados' && !cliente.id_cliente"
              fixed
              fab
              dark
              bottom
              right
              color="primary"
              @click="modalClienteEndereco = true"
            ><v-icon>mdi-map-marker-plus</v-icon>
            </v-btn>
          </v-fab-transition>

          <span class="body-2 font-weight-medium">Endereços</span>
          <template v-if="cliente.enderecos && cliente.enderecos.length">
            <v-card
              v-for="(endereco, i) in cliente.enderecos"
              :key="i"
              class="my-3"
              @click="editEndereco(endereco)"
              :disabled="permiteAlterar(endereco)"
            >
              <v-card-text class="d-flex align-center justify-space-between">
                <div class="d-flex align-center">
                  <v-avatar color="grey lighten-3" class="mr-3">
                    <v-icon>mdi-map-marker</v-icon>
                  </v-avatar>
                  <div class="body-2">
                    {{ enderecoText(endereco) }}
                    <div class="caption font-italic">
                      {{ endereco.titulo }}
                    </div>
                  </div>
                </div>
                <v-icon>mdi-chevron-right</v-icon>
              </v-card-text>
            </v-card>
          </template>
          <v-card v-else class="my-3">
            <v-card-text>Nenhum registro encontrado</v-card-text>
          </v-card>

          <!-- <v-card class="mt-3">
            <v-card-title class="flex-nowrap no-gutters justify-space-between">
              <v-col cols="8" md="10" lg="10">
                <v-select
                  v-model="cliente.endereco.titulo"
                  :items="cliente.enderecos"
                  item-text="titulo"
                  label="Endereço"
                  return-object
                  hide-details
                  solo flat
                  dense
                  prepend-icon="mdi-map-marker"
                  @change="changeEndereco"
                ></v-select>
              </v-col>
              <v-col cols="4" md="2" lg="2" class="text-center">
                <v-btn
                  color="primary"
                  icon
                  dark
                  class="mr-3"
                  @click="modalClienteEndereco = true"
                ><v-icon>mdi-plus</v-icon>
                </v-btn>
                <v-btn icon @click="editEndereco">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </v-col>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <p class="ma-0"><span class="font-weight-bold">Endereço:</span> {{ cliente.endereco.endereco }}<span v-if="cliente.endereco.numero">,</span> {{ cliente.endereco.numero }}</p>
              <p class="ma-0"><span class="font-weight-bold">Complemento:</span> {{ cliente.endereco.complemento }}</p>
              <p class="ma-0"><span class="font-weight-bold">P. Referência:</span> {{ cliente.endereco.ponto_referencia }}</p>
              <p class="ma-0"><span class="font-weight-bold">Bairro:</span> {{ cliente.endereco.bairro }}</p>
              <p class="ma-0"><span class="font-weight-bold">Cidade:</span> {{ cliente.endereco.cidade }}</p>
              <p class="ma-0"><span class="font-weight-bold">CEP:</span> {{ cliente.endereco.cep }}</p>
            </v-card-text>
          </v-card> -->
        </v-col>

        <!-- <v-col cols="12" class="pt-0">
          <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            color="error"
            @click="deleteCliente(cliente.id_cliente)"
          >Excluir</v-btn>
        </v-col> -->
      </v-row>

      <!-- Contato -->
      <v-row column slot="Contato" class="grey lighten-3">
        <ModalClienteTelefone
          :modal="modalClienteTelefone"
          :editClienteTelefone="editClienteTelefone"
          @close="closeModalClienteTelefone"
          @save="addClienteTelefone"
          @update="updateClienteTelefone"
        />
        <ModalClienteEmail
          :modal="modalClienteEmail"
          :editClienteEmail="editClienteEmail"
          @close="closeModalClienteEmail"
          @save="addClienteEmail"
          @update="updateClienteEmail"
        />
        <v-col cols="12" class="py-0">
          <span class="body-2 font-weight-medium">Telefones</span>
          <template v-if="cliente.telefones && cliente.telefones.length">
            <v-card
              v-for="(telefone, i) in cliente.telefones"
              :key="i"
              class="my-3"
              @click="editTelefone(telefone)"
              :disabled="permiteAlterar(telefone)"
            >
              <v-card-text class="d-flex align-center justify-space-between">
                <div class="d-flex align-center">
                  <v-avatar color="grey lighten-3" class="mr-3">
                    <v-icon>mdi-phone</v-icon>
                  </v-avatar>
                  <div>
                    <span class="body-1 font-weight-bold">{{ telefone.telefone }}</span><br>
                    <span class="body-2">{{ telefone.contato }}</span><br>
                    <span class="caption font-italic">{{ tipoTelefone(telefone.tipo_telefone) }}</span>
                  </div>
                </div>
                <v-icon>mdi-chevron-right</v-icon>
              </v-card-text>
            </v-card>
          </template>
          <v-card v-else class="my-3">
            <v-card-text>Nenhum registro encontrado</v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <span class="body-2 font-weight-medium">E-mails</span>
          <template v-if="cliente.emails && cliente.emails.length">
            <v-card
              v-for="(email, i) in cliente.emails"
              :key="i"
              class="my-3"
              @click="editEmail(email)"
              :disabled="permiteAlterar(email)"
            >
              <v-card-text class="d-flex align-center justify-space-between">
                <div class="d-flex align-center">
                  <v-avatar color="grey lighten-3" class="mr-3">
                    <v-icon>mdi-email</v-icon>
                  </v-avatar>
                  <div>
                    <span class="body-1 font-weight-bold text-break">{{ email.email }}</span><br>
                    <span class="caption font-italic">{{ tipoEmail(email.tipo_email) }}</span>
                  </div>
                </div>
                <v-icon>mdi-chevron-right</v-icon>
              </v-card-text>
            </v-card>
          </template>
          <v-card v-else class="my-3">
            <v-card-text>Nenhum registro encontrado</v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Info -->
      <v-row column slot="Info" class="grey lighten-3">
        <v-col cols="12">
          <CardTitle title="Configurações">
            <div class="d-flex justify-space-between align-center">
              <span>Limite Crédito</span>
              <p class="font-weight-bold mb-0">{{ cliente.limite_credito || 0 | price }}</p>
            </div>
            <div class="d-flex justify-space-between align-center">
              <span>Tabela Preço</span>
              <p class="font-weight-bold mb-0">{{ cliente.tabela_preco || 'Nenhuma' }}</p>
            </div>
            <div class="d-flex justify-space-between align-center">
              <span>Condição Pagamento</span>
              <p class="font-weight-bold mb-0">{{ cliente.condicao_pagamento || 'Nenhuma' }}</p>
            </div>
          </CardTitle>
        </v-col>

        <v-col cols="12" v-if="cliente && cliente.id_cliente">
          <CardTitle title="Financeiro">
            <Menu
              slot="actions"
              :items="financeiroItems"
              @atualizaInfoFinanceiro="atualizaInfoFinanceiro"
            />
            <template v-if="cliente.financeiro">
              <div class="d-flex justify-space-between align-center">
                <span>Total em Atraso</span>
                <p class="font-weight-bold mb-0 red--text">{{ cliente.financeiro.Total || 0 | price }}</p>
              </div>
              <div class="d-flex justify-space-between align-center">
                <span>Qtde em Atraso</span>
                <p class="font-weight-bold mb-0">{{ cliente.financeiro.Quantidade || 'Nenhum' }}</p>
              </div>
              <!-- <div class="d-flex justify-space-between align-center">
                <span>Último Vencimento</span>
                <p class="font-weight-bold mb-0">{{ ultimoVencimentoCliente }}</p>
              </div> -->
            </template>
            <div v-else>
              Nenhum registro encontrado
            </div>
          </CardTitle>
        </v-col>
      </v-row>
    </Navbar>

    <!-- Button Modal Telefone/Email -->
    <v-fab-transition>
      <v-speed-dial
        v-if="currentTab === 'tab-Contato' && !cliente.id_cliente"
        v-model="fab"
        fixed
        bottom
        right
        direction="top"
        transition="slide-y-reverse-transition"
      >
        <template v-slot:activator>
          <v-btn
            v-model="fab"
            color="primary"
            dark
            fab
          >
            <v-icon v-if="fab">mdi-close</v-icon>
            <v-icon v-else>mdi-plus</v-icon>
          </v-btn>
        </template>
        <v-btn
          fab
          dark
          small
          color="success"
          @click="modalClienteTelefone = true"
        ><v-icon>mdi-phone</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          small
          color="warning"
          @click="modalClienteEmail = true"
        ><v-icon>mdi-email</v-icon>
        </v-btn>
      </v-speed-dial>
    </v-fab-transition>

    <!-- Button Modal Parcelas -->
    <v-fab-transition>
      <v-btn
        v-if="currentTab === 'tab-Parcelas' && cliente.id_condicao_pagamento === 0"
        absolute
        fab
        dark
        bottom
        right
        color="success"
        style="bottom: 60px;"
        
      ><v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-fab-transition>
  </v-container>
  <PageLoading v-else />
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { clienteService } from '@/services/clienteService';
import Navbar from '@/components/layout/Navbar';
import ModalClienteEndereco from '@/components/shared/ModalClienteEndereco';
import ModalClienteTelefone from '@/components/shared/ModalClienteTelefone';
import ModalClienteEmail from '@/components/shared/ModalClienteEmail';
// import ModalCondicaoPagamento from '@/components/shared/ModalCondicaoPagamento';
// import ModalTabelaPreco from '@/components/shared/ModalTabelaPreco';
import Menu from '@/components/shared/Menu';
// import CardListItem from '@/components/shared/card/CardListItem';

export default {
  name: 'Cliente',
  props: ['id'],
  components: {
    Navbar,
    ModalClienteEndereco,
    ModalClienteTelefone,
    ModalClienteEmail,
    CardTitle: () => import('@/components/shared/CardTitle'),
    // ModalCondicaoPagamento,
    // ModalTabelaPreco,
    Menu,
    // CardListItem
  },
  data: () => ({
    cliente: null,
    clienteOriginal: null,
    editClienteEndereco: null,
    editClienteTelefone: null,
    editClienteEmail: null,
    modalClienteEndereco: false,
    modalClienteTelefone: false,
    modalClienteEmail: false,
    modalCondicaoPagamento: false,
    modalTabelaPreco: false,
    currentTab: null,
    observacoes: false,
    fab: false,
    valid: true,
    menuItems: [
      { title: 'Excluir', value: 'excluir', color: 'red--text' },
    ],
    financeiroItems: [
      { title: 'Atualizar', value: 'atualizaInfoFinanceiro' },
    ]
  }),
  computed: {
    ...mapGetters(['condicoesPagamento', 'tabelasPreco', 'tiposTelefone', 'tiposEmail', 'rules', 'realizaBackupAoSalvar']),
    ruleCpfCnpj() {
      if (this.cliente.tipo_pessoa === 'F') {
        return this.cliente.versao_imp !== undefined ? [this.rules.isCpfValid] : [];
      } else {
        return this.cliente.versao_imp !== undefined ? [this.rules.isCnpjValid] : [];
      }
    },
    // ultimoVencimentoCliente() {
    //   if (this.cliente.financeiro) {
    //     const vencimento = this.cliente.financeiro.UltimoVencimento;

    //     return vencimento === '1899-12-30' ? 'Nenhum' : this.$options.filters.dateMonthYear(vencimento);
    //   }

    //   return 'Nenhum';
    // },
    computedTipoPessoa: {
      get() {
        return this.cliente.tipo_pessoa.trim();
      },
      set(value) {
        this.cliente.tipo_pessoa = value.trim();
      }
    },
  },
  methods: {
    ...mapActions([
      'fetchClienteDetalhesAPI',
      'fetchClienteFinanceiroAPI',
      // 'fetchClienteEnderecosAPI', 
      // 'fetchClienteTelefonesAPI', 
      // 'fetchClienteEmailsAPI', 
      'updateCliente', 
      'deleteCliente', 
      'gerarCliente',
      'verifyAndSendBackupOnline'
    ]),
    ...mapMutations(['SHOW_SNACKBAR']),
    async atualizaInfoFinanceiro() {
      await this.fetchClienteFinanceiroAPI(this.cliente);
      this.getCliente();
    },
    permiteAlterar(obj) {
      return obj.versao_imp !== undefined ? false : true;
    },
    enderecoText(endereco) {
      const text =
        `${endereco.logradouro || ''} ${endereco.numero || ''} ${endereco.complemento || ''} ${endereco.ponto_referencia || ''} 
        ${endereco.bairro || ''} ${endereco.cidade || ''} ${endereco.cep || ''}`;
      
      return text;
    },
    tipoEmail(tipo) {
      const tipoEmail = this.tiposEmail.find(t => t.descricao.startsWith(tipo));
      return tipoEmail ? tipoEmail.descricao : '';
    },
    tipoTelefone(tipo) {
      const tipoTelefone = this.tiposTelefone.find(t => t.descricao.startsWith(tipo));
      return tipoTelefone ? tipoTelefone.descricao : '';
    },
    getCondicoesPagamento() {
      if (!this.condicoesPagamento.length) this.fetchCondicoesPagamento();
    },
    getTabelasPreco() {
      if (!this.tabelasPreco.length) this.fetchTabelasPreco();
    },
    statusColor(status) {
      if (status.startsWith('A')) return 'success';
      if (status.startsWith('I')) return 'warning';
      if (status.startsWith('C')) return 'secondary';
      return 'error'
    },
    statusText(status) {
      if (status.startsWith('A')) return 'Ativo';
      if (status.startsWith('I')) return 'Inativo';
      if (status.startsWith('C')) return 'Excluído';
      return 'NDA'
    },
    changeNomeRazaoSocial(text) {
      if (this.cliente.nome_fantasia === '') this.cliente.nome_fantasia = text;
    },
    changeCondicaoPagamento(condicaoPagamento) {
      if (condicaoPagamento && typeof condicaoPagamento === 'object') {
        this.cliente.id_condicao_pagamento = condicaoPagamento.id_condicao_pagamento;
        this.cliente.condicao_pagamento = condicaoPagamento.condicao_pagamento;
      } else {
        this.cliente.id_condicao_pagamento = null;
        this.cliente.condicao_pagamento = '';
      }

      this.modalCondicaoPagamento = false;
    },
    changeTabelaPreco(tabelaPreco) {
      if (tabelaPreco && typeof tabelaPreco === 'object') {
        this.cliente.id_tabela_preco = tabelaPreco.id_tabela_preco;
        this.cliente.tabela_preco = tabelaPreco.descricao;
      } else {
        this.cliente.id_tabela_preco = null;
        this.cliente.tabela_preco = '';
      }

      this.modalTabelaPreco = false;
    },
    prepareCliente() {
      return { ...this.cliente };
    },
    validateCliente() {
      return this.$refs.formCliente.validate();
    },
    // Modal Cliente Email
    closeModalClienteEmail() {
      this.editClienteEmail = null;
      this.modalClienteEmail = false;
    },
    editEmail(email) {
      this.editClienteEmail = { ...email };
      const tipoEmail = this.tiposEmail.find(tipo => tipo.descricao.startsWith(email.tipo_email));
      this.editClienteEmail.tipo_email = tipoEmail.descricao;
      this.modalClienteEmail = true;
    },
    updateClienteEmail(clienteEmail) {
      const index = this.cliente.emails.findIndex(email => email.id_item === clienteEmail.id_item);
      if (index !== -1) {
        clienteEmail.tipo_email = clienteEmail.tipo_email[0];
        this.cliente.emails.splice(index, 1, clienteEmail);
      }
      this.closeModalClienteEmail();
    },
    getLastIdEmail() {
      const lastEmail = this.cliente.emails[this.cliente.emails.length - 1];
      if (lastEmail) return lastEmail.id_item + 1;
      else return 1;
    },
    addClienteEmail(clienteEmail) {
      const newClienteEmail = { ...clienteEmail };
      newClienteEmail.id_cliente = this.cliente.id_cliente;
      newClienteEmail.id_item = this.getLastIdEmail();
      newClienteEmail.tipo_email = newClienteEmail.tipo_email[0];
      this.cliente.emails.push(newClienteEmail);
      this.closeModalClienteEmail();
    },
    // Modal Cliente Endereco
    closeModalClienteEndereco() {
      this.editClienteEndereco = null;
      this.modalClienteEndereco = false;
    },
    editEndereco(endereco) {
      this.editClienteEndereco = { ...endereco };
      this.modalClienteEndereco = true;
    },
    updateClienteEndereco(clienteEndereco) {
      const index = this.cliente.enderecos.findIndex(endereco => endereco.id_item === clienteEndereco.id_item);
      if (index !== -1) {
        clienteEndereco.tipo = clienteEndereco.titulo[0];
        this.cliente.enderecos.splice(index, 1, clienteEndereco);
        // this.cliente.endereco = { ...clienteEndereco };
      }
      this.closeModalClienteEndereco();
    },
    getLastIdEndereco() {
      const lastEndereco = this.cliente.enderecos[this.cliente.enderecos.length - 1];
      if (lastEndereco) return lastEndereco.id_item + 1;
      else return 1;
    },
    existeEnderecoDoTipoResidencial() {
      const enderecoResidencial = this.cliente.enderecos.find(endereco => endereco.id_tipo_endereco == 1);
      return !!enderecoResidencial;
    },
    addClienteEndereco(clienteEndereco) {
      if (clienteEndereco.titulo.startsWith('R') && this.existeEnderecoDoTipoResidencial()) {
        this.SHOW_SNACKBAR({ text: `Já existe um endereço do tipo: ${clienteEndereco.titulo}!`, status: 'error' });
        return;
      } else {
        const newClienteEndereco = { ...clienteEndereco };
        newClienteEndereco.id_cliente = this.cliente.id_cliente;
        newClienteEndereco.id_item = this.getLastIdEndereco();
        newClienteEndereco.tipo = newClienteEndereco.titulo[0];
        this.cliente.enderecos.push(newClienteEndereco);
        // this.cliente.endereco = { ...newClienteEndereco };
        this.closeModalClienteEndereco();
      }
    },
    // changeEndereco(endereco) {
    //   this.cliente.endereco = { ...endereco };
    // },
    // Modal Cliente Telefone
    closeModalClienteTelefone() {
      this.editClienteTelefone = null;
      this.modalClienteTelefone = false;
    },
    editTelefone(telefone) {
      this.editClienteTelefone = { ...telefone };
      const tipoTelefone = this.tiposTelefone.find(tipo => tipo.descricao.startsWith(telefone.tipo_telefone));
      this.editClienteTelefone.tipo_telefone = tipoTelefone.descricao;
      this.modalClienteTelefone = true;
    },
    updateClienteTelefone(clienteTelefone) {
      const index = this.cliente.telefones.findIndex(telefone => telefone.id_cliente_telefone === clienteTelefone.id_cliente_telefone);
      if (index !== -1) {
        clienteTelefone.tipo_telefone = clienteTelefone.tipo_telefone[0];
        this.cliente.telefones.splice(index, 1, clienteTelefone);
      }
      this.closeModalClienteTelefone();
    },
    getLastIdTelefone() {
      const lastTelefone = this.cliente.telefones[this.cliente.telefones.length - 1];
      if (lastTelefone) return lastTelefone.id_cliente_telefone + 1;
      else return 1;
    },
    addClienteTelefone(clienteTelefone) {
      const newClienteTelefone = { ...clienteTelefone };
      newClienteTelefone.id_cliente = this.cliente.id_cliente;
      newClienteTelefone.id_cliente_telefone = this.getLastIdTelefone();
      newClienteTelefone.tipo_telefone = newClienteTelefone.tipo_telefone[0];
      this.cliente.telefones.push(newClienteTelefone);
      this.closeModalClienteTelefone();
    },
    existeModificacoes() {
      if (this.cliente.tipo_pessoa !== this.clienteOriginal.tipo_pessoa) return true;
      if (this.cliente.razao_social !== this.clienteOriginal.razao_social) return true;
      if (this.cliente.nome_fantasia !== this.clienteOriginal.nome_fantasia) return true;
      if (this.cliente.contato !== this.clienteOriginal.contato) return true;
      if (this.cliente.cpf_cnpj !== this.clienteOriginal.cpf_cnpj) return true;
      if (this.cliente.rg_ie !== this.clienteOriginal.rg_ie) return true;
      if (this.cliente.inscricao_municipal !== this.clienteOriginal.inscricao_municipal) return true;
      if (this.cliente.enderecos.length !== this.clienteOriginal.enderecos.length) return true;
      if (this.cliente.telefones.length !== this.clienteOriginal.telefones.length) return true;
      if (this.cliente.emails.length !== this.clienteOriginal.emails.length) return true;
      return false;
    },
    cancel() {
      if (this.existeModificacoes() && confirm('Existem modificações!! Tem certeza que deseja voltar?')) {
        if (!this.clienteOriginal.razao_social) this.deleteCliente(this.cliente.id_interno);

        return this.$router.go(-1);
      } else if (!this.existeModificacoes() && !this.cliente.id_cliente) {
        if (!this.clienteOriginal.razao_social) this.deleteCliente(this.cliente.id_interno);

        this.$router.go(-1);
      } else if (!this.existeModificacoes() && this.cliente.id_cliente) {
        this.$router.go(-1);
      }
    },
    async save() {
      if (this.validateCliente()) {
        const updCliente = this.prepareCliente();
        try {
          await this.updateCliente(updCliente);
          if (this.realizaBackupAoSalvar) this.verifyAndSendBackupOnline();
          this.$router.go(-1);
          // this.SHOW_SNACKBAR({ text: 'Cliente atualizado com sucesso.', status: 'success' });
        } catch (error) {
          console.log(error);
          this.SHOW_SNACKBAR({ text: error, status: 'error' });
        }
      }
    },
    async getCliente() {
      try {
        const cliente = await clienteService.getCliente(this.id);
        
        if (cliente.id_cliente) {
          // TODO: Verificar se vai ser assim mesmo, buscando os detalhes do cliente direto
          // Como no GET (POST Acao=lista) padrão dos clientes não vem os telefones, emails
          // Se faz necessário fazer o GET direto no idCliente para trazer esses campos
          const clienteDetalhes = await this.fetchClienteDetalhesAPI(cliente);
          this.cliente = clienteDetalhes;
          this.clienteOriginal = JSON.parse(JSON.stringify(clienteDetalhes));
        } else if (cliente) {
          this.cliente = cliente;
          this.clienteOriginal = JSON.parse(JSON.stringify(cliente));
        } else {
          this.error = 'Cliente não encontrado.';
        }
      } catch (error) {
        this.error = 'Cliente não encontrado.';
        console.log(error);
      }
    },
    async removeCliente() {
      if (confirm(`Deseja excluir o registro ${this.cliente.id_interno}?`)) {
        await this.deleteCliente(this.cliente.id_interno);
        this.$router.go(-1);
        // this.SHOW_SNACKBAR({ text: 'Registro excluído com sucesso.', status: 'success' });
      }
    }
  },
  created() {
    this.getCliente();
  },
}
</script>

<style scoped>
</style>